// Payvantage weekly estimate factor — must match LeaseCalculator's weekly rate.
export const WEEKLY_FACTOR = 0.04231;

// Returns the estimated weekly lease payment as a 2-decimal string, e.g. "42.31".
export const weeklyLease = (price) =>
  (Number(price || 0) * WEEKLY_FACTOR).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
